/**
 * EmailAuditoriaNivel
 */
import {$, HttpBody, ID, Resource, ResponseSerialize, TAG} from 'simpli-web-sdk'
import {
  ValidationMaxLength,
  ValidationRequired,
} from 'simpli-web-sdk'
import EmailNivelSchema from '@/schema/EmailNivel.schema'
import Responsavel from '@/model/resource/Responsavel'
import EmailAuditoria from '@/model/resource/EmailAuditoria'

export default class EmailNivel extends Resource {

  get $schema() {
    return EmailNivelSchema(this)
  }

  get $id() {
    return this.idEmailNivelPk
  }
  set $id(val: ID) {
    this.idEmailNivelPk = val
  }

  get $tag() {
      return this.titulo
  }
  set $tag(val: TAG) {
      this.titulo = val
  }

  readonly $name: string = 'EmailNivel'

  readonly $endpoint: string = '/user/email-auditoria/email-nivel'

  idEmailNivelPk: ID = 0

  titulo: string = ''

  async getEmailNivel(spinner = 'getEmailNivel') {
    const fetch = async () => await this.GET(`/user/email-auditoria/email-nivel`)
    return await $.await.run(fetch, spinner)
  }

  async getGrupoNivel(model: EmailAuditoria, spinner = 'getGrupoNivel') {
    const fetch = async () => {
      await model.validate()
      return await this.GET(`/user/email-auditoria/grupo-nivel/${model.idEmailAuditoriaPk}`)
    }

    return await $.await.run(fetch, spinner)
  }

}
